import { render, staticRenderFns } from "./rdsinstances.vue?vue&type=template&id=39969ed3&"
import script from "./rdsinstances.vue?vue&type=script&lang=js&"
export * from "./rdsinstances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports